//export const serverUrl = "http://localhost:3001"
export const serverUrl = "https://backend-partner-toolbox.doceree.com"
export const EMAIL_IS_IN_USE = "Failed! Email is already in use!"
export const REGISTRATION_REQUEST_SUCCESS = "Signup request submitted."
export const USER_REGISTERED_SUCCESS = "User was registered successfully!"